(function SecureStorage($, Adzuki)
{
	"use strict";

	var SecureStorage = {};

	var _detokenize,
	    _init;

	_detokenize = function _detokenize(params)
	{
		var post_data = 'captcha_type=' + encodeURIComponent(params.captcha_type) + '&captcha_response=' + encodeURIComponent(params.captcha_response);

		$.each(params.secure_storage_tokens, function each(i, val) {
			post_data += '&secure_storage_tokens[]=' + encodeURIComponent(val);
		});

		Adzuki.Ajax.post(
			'/SecureStorage/getIframeUrls',
			post_data
		).then(function success(iframe_urls) {
			var plain_texts      = [],
			    decrypt_function;

			if (iframe_urls === false || iframe_urls === 'mcp_login') {
				if (typeof params.error === 'function') {
					params.error(iframe_urls);
				}

				return;
			}

			decrypt_function = function decrypt()
			{
				var iframe_url = iframe_urls.shift();

				Adzuki.Ajax.get(iframe_url)
				.then(function success(raw_iframe_content) {
					var match      = raw_iframe_content.match(/<input[^>]* id="data"[^>]* value="([^"]*)"[^>]*\/>/i),
						plain_text;

					if (match !== null) {
						plain_text = match[1];

						if (typeof params.success === 'function') {
							plain_texts.push(plain_text);

							if (iframe_urls.length === 0) {
								params.success(plain_texts);
							} else {
								setTimeout(decrypt_function, 1);
							}
						}
					} else if (typeof params.error === 'function') {
						params.error();
					}
				}, function failure(response) {
					if (typeof params.error === 'function') {
						params.error();
					}
				});
			};

			decrypt_function();
		}, function failure(response) {
			if (typeof params.error === 'function') {
				params.error();
			}
		});
	};

	_init = function _init()
	{
		$('.secure-storage-view').on('click', function click(e) {
			var secure_tokens            = [],
			    $click_element           = $(this),
			    $token_element           = $click_element.prev('[data-token]'),
			    secure_storage_token     = $token_element.data('token'),
			    $ccv_token_element       = $click_element.next('[data-ccv_token]'),
			    secure_storage_ccv_token = $ccv_token_element.data('ccv_token'),
			    secure_storage_ccv_exp   = $ccv_token_element.data('ccv_expiration'),
			    ccv_string               = 'Security Code Removed ',
			    $ccv_warning_element     = $ccv_token_element.next('.ccv_warning');

			e.preventDefault();

			if (secure_storage_ccv_token === undefined) {
				secure_storage_ccv_token = '';
			}

			if (typeof $token_element.data('old-html') === 'undefined') {
				secure_tokens[0] = secure_storage_token;

				if (secure_storage_ccv_token !== '') {
					secure_tokens[1] = secure_storage_ccv_token;
				}

				SecureStorage.detokenize({
					secure_storage_tokens: secure_tokens,
					success              : function success(plain_texts) {
						if ($token_element.prop('nodeName') === 'INPUT') {
							// placing cc number into input field
							$token_element.val(plain_texts[0]);

							// placing ccv into input field
							if (plain_texts.length === 2) {
								$ccv_token_element.val(plain_texts[1]);
							}
						} else {
							// display cc number
							$token_element.data('old-html', $token_element.html());
							$token_element.html(plain_texts[0]);

							// display ccv
							if (secure_storage_ccv_exp !== '') {
								if (secure_storage_ccv_token !== '') {
									ccv_string = 'Security Code: ' + plain_texts[1];
								}

								$ccv_token_element.data('old-html', $ccv_token_element.html());
								$ccv_token_element.html('<br>' + ccv_string);
								$ccv_warning_element.removeClass('hidden');
							}
						}

						if ($click_element.prop('nodeName') === 'A') {
							$click_element.find(Adzuki.FaIcon.getIconSelectorName('search')).data('original-tooltip', $click_element.find(Adzuki.FaIcon.getIconSelectorName('search')).attr('data-original-title'));
							$click_element.find(Adzuki.FaIcon.getIconSelectorName('search')).attr('data-original-title', 'Click to hide.');

							$click_element.find(Adzuki.FaIcon.getIconSelectorName('search')).addClass(Adzuki.FaIcon.getIconStyleName('close'));
							$click_element.find(Adzuki.FaIcon.getIconSelectorName('search')).removeClass(Adzuki.FaIcon.getIconStyleName('search'));
						}
					}
				});
			} else {
				if ($click_element.prop('nodeName') === 'A') {
					$click_element.find(Adzuki.FaIcon.getIconSelectorName('close')).attr('data-original-title', $click_element.find(Adzuki.FaIcon.getIconSelectorName('close')).data('original-tooltip'));

					$click_element.find(Adzuki.FaIcon.getIconSelectorName('close')).addClass(Adzuki.FaIcon.getIconStyleName('search'));
					$click_element.find(Adzuki.FaIcon.getIconSelectorName('close')).removeClass(Adzuki.FaIcon.getIconStyleName('close'));
				}

				if ($token_element.prop('nodeName') !== 'INPUT') {
					$token_element.html($token_element.data('old-html'));
					$token_element.removeData('old-html');

					$ccv_token_element.html($ccv_token_element.data('old-html'));
					$ccv_token_element.removeData('old-html');
					$ccv_warning_element.addClass('hidden');
				}
			}
		});
	};

	SecureStorage.detokenize = function detokenize(params)
	{
		var $modal;

		if (typeof params.captcha_type === 'undefined') {
			params.captcha_type = 'recaptcha';
		}

		if (params.captcha_type === 'recaptcha') {
			$modal = $('.modal');

			$modal.find('.modal-dialog').addClass('secure-storage');
			$modal.find('.modal-title').text('Retrieving Sensitive Data');
			$modal.find('.modal-body').html('<div id="recaptcha"></div>');

			$modal.on('hidden.bs.modal', function _restoreModal() {
				$modal.find('.modal-dialog').removeClass('secure-storage');
				$modal.off('hidden.bs.modal');
			});

			$modal.modal('show');

			// eslint-disable-next-line no-undef
			grecaptcha.render('recaptcha', {
				sitekey : '6Lc4PsEUAAAAAOeebghaSek0b9azuRQ9ejXTgaiG',
				callback: function _callback(recaptcha_response_token) {
					$modal.find('.modal-body').html('<img src="' + Adzuki.base_uri + '/adzuki/images/ajax-loader.gif"> Getting Data...');

					_detokenize({
						captcha_type         : 'recaptcha',
						captcha_response     : recaptcha_response_token,
						secure_storage_tokens: params.secure_storage_tokens,
						success              : function success(plain_texts) {
							if (typeof params.success === 'function') {
								params.success(plain_texts);
							}

							$modal.modal('hide');
						},
						error: function error(error) {
							if (typeof params.error === 'function') {
								params.error();
							}

							$modal.modal('hide');

							if (error === 'mcp_login') {
								Adzuki.StatusMessage('Error', 'HO staff members logged in as agents cannot access sensitive data');
							} else {
								Adzuki.StatusMessage('Error', 'Unable to retrieve sensitive data');
							}
						},
					});
				}
			});
		}
	};

	$(document).ready(function documentReady()
	{
		_init();
	});

	Adzuki.SecureStorage = SecureStorage;
}(jQuery, window.Adzuki || {}));
